import { render, staticRenderFns } from "./AteUnitTestingExam.vue?vue&type=template&id=5e1d1cdf"
import script from "./AteUnitTestingExam.vue?vue&type=script&lang=js"
export * from "./AteUnitTestingExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports